module.exports = __webpack_public_path__ + "img/od.dce35535.png";